import React from 'react' // eslint-disable-line no-unused-vars
import { Route, Redirect } from 'react-router'
import { connect } from 'react-redux'
import { PERMISSIONS } from './constants'
import { defaultPermissions } from './reducers/permission'

class ProtectedRoute extends React.Component {
  render () {
    const { component: Component, requiredPermission, renderFunction,redirectPath, ...rest } = this.props
    return (
      <Route
        {...rest} render={props => (
          requiredPermission === PERMISSIONS.PUBLIC || this.props.permissions.includes(requiredPermission)
            ? Component
              ? <Component {...props} />
              : renderFunction(props)
            : this.props.permissions === defaultPermissions
              ? <div style={{ marginTop: '20px', marginLeft: '20px' }}>{this.props.pageContent.content.module.submitInquiry.loading}</div>
              : <Redirect to={redirectPath?redirectPath:'/noaccess'} />
        )}
      />
    )
  }
}

function mapStateToProps ({ permissions, pageContent }) {
  return {
    permissions,
    pageContent
  }
}

export default connect(mapStateToProps, null)(ProtectedRoute)



// WEBPACK FOOTER //
// ./src/ProtectedRoute.js